import { gql } from 'graphql-tag';

export default gql`
  query FormatBlockEdd(
    $eddCombos: [DisplayDateFormatCombo!]!
    $retailerMoniker: String!
    $versionName: String
    $localeLanguage: Language
    $localeCountry: Country
  ) {
    formatEdd(
      eddCombos: $eddCombos
      retailerMoniker: $retailerMoniker
      versionName: $versionName
      localeLanguage: $localeLanguage
      localeCountry: $localeCountry
    ) {
      formattedEdds
    }
  }
`;
